import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { ProductInformation } from "shared/types/__generated__/graphql"

import { ProductExternalDimensioning } from "entities/products/ui/product-external-dimensioning/ProductExternalDimensioning"

type ProductPageExternalDimensioningProps = Omit<
  React.ComponentPropsWithoutRef<"section">,
  "ref"
> & {
  productInformation: ProductInformation | null | undefined
  isLoading?: boolean
}

function ProductPageExternalDimensioningComponent({
  productInformation,
  isLoading,
  className,
  ...rest
}: ProductPageExternalDimensioningProps) {
  const { t } = useTranslation()

  const dimensioning = productInformation?.dimensioning

  if (!dimensioning) {
    return null
  }

  return (
    <section
      {...rest}
      className={classNames(
        "product-page__external-dimensioning product-page__section card card--elevated",
        className
      )}
    >
      <h3 className="product-page__section-title">
        {t("Product.Configuration.Dimensioning")}
      </h3>
      <ProductExternalDimensioning
        productInformation={productInformation}
        isLoading={isLoading}
      />
    </section>
  )
}

export const ProductPageExternalDimensioning = React.memo(
  ProductPageExternalDimensioningComponent
)
